import 'trix';
import i18n from '@/i18n';
import 'trix/dist/trix.css';
import VueTippy from 'vue-tippy';
import 'tippy.js/dist/tippy.css';
import { createApp, h } from 'vue';
import { createPinia } from 'pinia';
import { flare } from '@flareapp/js';
import { register } from 'timeago.js';
import Toast from 'vue-toastification';
import 'vue-tel-input/vue-tel-input.css';
import { flareVue } from '@flareapp/vue';
import 'vue-toastification/dist/index.css';
import VueClickAway from 'vue3-click-away';
import Default from '@/Layouts/Default.vue';
import { createInertiaApp } from '@inertiajs/vue3';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
register('fr', (number: number, index: number, totalSec: number) => {
  // number: the timeago / timein number;
  // index: the index of array below;
  // totalSec: total seconds between date to be formatted and today's date;
  return [
    ['à l\'instant', 'maintenant'],
    ['il y a %s secondes', 'dans %s secondes'],
    ['il y a 1 minute', 'dans 1 minute'],
    ['il y a %s minutes', 'dans %s minutes'],
    ['il y a 1 heure', 'dans 1 heure'],
    ['il y a %s heures', 'dans %s heures'],
    ['il y a 1 jour', 'dans 1 jour'],
    ['il y a %s jours', 'dans %s jours'],
    ['il y a 1 semaine', 'dans 1 semaine'],
    ['il y a %s semaines', 'dans %s semaines'],
    ['il y a 1 mois', 'dans 1 mois'],
    ['il y a %s mois', 'dans %s mois'],
    ['il y a 1 an', 'dans 1 an'],
    ['il y a %s ans', 'dans %s ans'],
  ][index];
});

if (import.meta.env.MODE === 'production') {
  flare.light();
}

createInertiaApp({
  progress: {
    color: '#3c4dab',
    showSpinner: true,
  },
  resolve: name => {
    const pages = import.meta.glob('./Pages/**/*.vue');

    return pages[`./Pages/${name}.vue`]().then(page => {
      // Apply default layout if not explicitly defined on the page
      page.default.layout = page.default.layout || Default;

      return page;
    });
  },
  setup: ({ el, App, props, plugin }) => {
    createApp({ render: () => h(App, props) })
      .use(flareVue)
      .use(plugin)
      .use(i18n)
      .use(Toast)
      .use(VueTippy)
      .use(VueClickAway)
      .use(createPinia())
      .mount(el);
  },
});
